import * as fromQuestions from './questions/actions';
import * as fromOfferings from './offerings/actions';
import * as fromContributors from './contributors/actions';
import * as fromOverlay from './overlay/actions';
import * as fromEvents from './events/actions';
import * as fromProjects from './projects/actions';
import * as fromLayout from './layout/actions';

export default {
    ...fromQuestions.default,
    ...fromOfferings.default,
    ...fromContributors.default,
    ...fromOverlay.default,
    ...fromEvents.default,
    ...fromProjects.default,
    ...fromLayout.default,
};